import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse } from "@/types";

export function useGetPlaces(query: string) {
  return useQuery({
    enabled: !!query,
    queryKey: ["places", query],
    queryFn: async () => {
      const queryParams = new URLSearchParams();

      if (query) {
        queryParams.append("filter", JSON.stringify({ input: query }));
      }

      const path = `places?${queryParams.toString()}`;
      const res = await guacHttpClient.get<string[], HttpResponse<string[]>>(
        path,
      );

      return res.data;
    },
  });
}
